import { render, staticRenderFns } from "./form.layout.vue?vue&type=template&id=9da3f0b2&"
import script from "./form.layout.vue?vue&type=script&lang=js&"
export * from "./form.layout.vue?vue&type=script&lang=js&"
import style0 from "./form.layout.vue?vue&type=style&index=0&lang=css&"


/* normalize component */
import normalizer from "!../../../../../../../tmp/ffsecurity-ui/node_modules/@vue/cli-service/node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports